import classNames from 'classnames';
import React from 'react';
import styles from './UserInitials.module.scss';

const getInitials = (name: string) => {
  const names = name.split(' ');
  let initials = names[0].charAt(0);

  if (names.length > 1) {
    initials += names[names.length - 1].charAt(0);
  }

  return initials;
};

interface Props {
  name: string | null | undefined;
  className?: string;
  style?: React.CSSProperties;
}
const UserInitials = (props: Props) => (
  <div
    style={props.style}
    className={classNames(styles.initials, props.className)}
    data-testid="user_initials"
  >
    {getInitials(props.name ?? '')}
  </div>
);
export default UserInitials;
